import { Injectable } from '@angular/core';

export interface DeactivationStatus {
  confirmationModalDisplayedToTheUser: boolean;
  proceed: boolean;
}

@Injectable()
export class ActiveComponentService {
  public activeComponent: any;

  public;

  public async canDeactivate(logoutInProgress = false): Promise<DeactivationStatus> {
    if (this.activeComponent && this.activeComponent.canDeactivate) {
      return {
        confirmationModalDisplayedToTheUser: true,
        proceed: await this.activeComponent.canDeactivate(logoutInProgress),
      };
    } else {
      return {
        confirmationModalDisplayedToTheUser: false,
        proceed: true,
      };
    }
  }
}
